const WIDGET_TYPE = {
  graphBoxes: 'graphBoxes',
  alarms: 'alarms',
  pivotTable: 'pivotTable',
  table: 'table',
  graph: 'graph',
  pieChartTable: 'pieChartTable',
  analyticTable: 'analyticTable',
  creative: 'creative',
  singleMetric: 'singleMetric',
  notepad: 'notepad',
  smallTable: 'smallTable',
  dummnyWidget: 'dummyWidget',
  goal: 'goal',
  goalChild: 'goalChild',
  aiInsight: 'aiInsight',
  abTesting: 'abTesting',
  filter: 'filter',
};

const DEFAULT_DATE_FILTER = {
  type: 'relative',
  values: {
    relative: {
      value: 30,
      unit: 'D',
    },
  },
};

const DEFAULT_COMPARISON_DATE_FILTER = {
  type: 'relative',
  values: {
    relative: {
      period: 'previous',
    },
  },
};

const DEFAULT_CONFIG = {
  dateFilter: DEFAULT_DATE_FILTER,
  filterTagList: [],
  type: 'overview',
  widgets: [],
};

const DEFAULT_DIMENSIONS = ['channel', 'campaign', 'adSet', 'ad'];

const DEFAULT_METRIC_BOXES = null;

const DEFAULT_PIVOT_TABLE_COLUMNS = [
  'status',
  'subChannels',
  'budget',
  'spend',
  'impressions',
  'clicks',
  'cpc',
  'ctr',
  'cpm',
];

const DEFAULT_GRAPHBOXES_COLUMNS = ['spend', 'impressions', 'clicks', 'cpc', 'ctr', 'cpm'];

const DEFAULT_CAMPAIGN_COLUMNS = [
  'subChannels',
  'conversionRate',
  'status',
  'conversionEvents',
  'budget',
  'totalPixelConversions',
  'totalGAConversions',
  'totalOtherConversions',
  'cpa',
  'clicks',
  'ctr',
  'cpc',
  'cpm',
  'impressions',
  'spend',
  'reach',
  'frequency',
  'bounceRate',
  'visitDuration',
  'amountSpentPercentage',
  'starts',
  'ends',
  'level',
];

const DEFAULT_AUDIENCE_COLUMNS = [
  'campaignName',
  'adSetName',
  'subChannels',
  'totalPixelConversions',
  'totalGAConversions',
  'totalOtherConversions',
  'cpa',
  'clicks',
  'ctr',
  'cpc',
  'impressions',
  'spend',
];

const DEFAULT_CREATIVE_COLUMNS = [
  'status',
  'adSetName',
  'campaignName',
  'subChannels',
  'conversionEvent',
  'totalPixelConversions',
  'totalGAConversions',
  'totalOtherConversions',
  'cpa',
  'clicks',
  'engagements',
  'ctr',
  'cpc',
  'cpm',
  'impressions',
  'spend',
  'reach',
  'frequency',
  'bounceRate',
  'visitDuration',
  'starts',
  'ends',
];

const DEFAULT_SUBCHANNEL_COLUMNS = [
  'totalPixelConversions',
  'totalGAConversions',
  'totalOtherConversions',
  'spend',
  'budget',
  'cpa',
  'cpc',
  'cpm',
  'ctr',
  'clicks',
  'impressions',
  'reach',
];

const DEFAULT_ATTRIBUTION_WINDOWS = ['1d_view', '7d_click', 'default'];

const UUID_V4_VALUES = {
  overview: [
    '2f239c3d-391f-4558-9b1f-75481d437321',
    'b3f74797-4b72-4501-b4e1-ef02143fbbbc',
    '0bb2d413-f720-4e99-958a-752ed8d3f3a9',
    '403ced80-41fb-4286-8666-cee2b2d784b9',
    '34545595-7ae1-4349-889d-9df10c4bb408',
    'efec16a8-864d-4a74-a055-77251e03d61a',
    'bb3f76bb-8aa7-41de-a8b9-fffc0ec2d6b3',
    '00f987b3-1f7d-493d-a367-7b0f01ac3563',
    '0e9b5af5-2a46-4828-b8b0-691d02ac6181',
    'aaafa6f4-0d77-485a-b312-38eb879eed60',
    '22b894f3-8ca1-4553-9401-7d0ea7e7d1c5',
    '632e62d5-2809-44c7-ae47-177181d3ebb5',
    'f62e0545-cc8c-45f2-a6ec-50a92f4643cd',
  ],
  audience: [
    'dd1e1e9c-8b5b-4687-8c02-8d96ee3fa34b',
    'd0d23d57-ac68-4b60-a510-c5f27a692895',
    '4b737a1d-1dbc-474a-81f7-ccd36109105e',
    '62f2021f-0390-4c8c-bbcf-3c35bb726323',
    '198e6020-12db-4f37-873d-ad7fc255c71c',
    'caa89158-6565-445b-8a01-5f08203efaeb',
  ],
  creatives: [
    '8bdf1d6c-b557-47d5-b593-78437d068835',
    'b3242b00-c402-4abc-93a3-db800591abe3',
    'ff03f927-a793-4e69-ada9-5531e550573b',
    '7d754708-856d-4dbd-9075-6a1b396fe08f',
    'a461c748-dae2-40da-bda7-86de6eee8980',
  ],
  keywords: ['943c7ec8-ea2e-41a5-9271-6c5ec154bc03'],
  performance: ['858f7460-e917-42d0-aa8b-d2f337e707bc', 'a1d7012e-86ff-463f-a4dd-be606ada60d6'],
};

const INITIAL_VIEW_LAYOUT = {
  overview: [
    { h: 6, w: 3, x: 0, y: 0 },
    { h: 18, w: 3, x: 0, y: 29 },
    { h: 18, w: 3, x: 3, y: 29 },
    { h: 12, w: 5, x: 1, y: 6 },
    { h: 29, w: 6, x: 0, y: 62 },
    { h: 10, w: 12, x: 0, y: 91 },
    { h: 6, w: 1, x: 4, y: 0 },
    { h: 6, w: 1, x: 5, y: 0 },
    { h: 6, w: 1, x: 3, y: 0 },
    { h: 12, w: 1, x: 0, y: 6 },
    { h: 15, w: 6, x: 0, y: 47 },
    { h: 11, w: 3, x: 3, y: 18 },
    { h: 11, w: 3, x: 0, y: 18 },
  ],
  audience: [
    { h: 7, w: 6, x: 0, y: 16 },
    { h: 10, w: 24, x: 0, y: 23 },
    { h: 10, w: 24, x: 0, y: 33 },
    { h: 16, w: 2, x: 0, y: 0 },
    { h: 16, w: 2, x: 2, y: 0 },
    { h: 16, w: 2, x: 4, y: 0 },
  ],
  creatives: [
    { h: 16, w: 6, x: 0, y: 15 },
    { h: 15, w: 6, x: 0, y: 0 },
    { h: 18, w: 2, x: 0, y: 31 },
    { h: 18, w: 2, x: 0, y: 31 },
    { h: 18, w: 2, x: 2, y: 31 },
  ],
  keywords: [{ h: 10, w: 24, x: 0, y: 0 }],
  performance: [
    { h: 16, w: 24, x: 0, y: 0 },
    { h: 10, w: 24, x: 0, y: 0 },
  ],
};

module.exports = {
  WIDGET_TYPE,
  DEFAULT_DATE_FILTER,
  DEFAULT_DIMENSIONS,
  DEFAULT_METRIC_BOXES,
  DEFAULT_PIVOT_TABLE_COLUMNS,
  DEFAULT_CONFIG,
  // DEFAULT_CAMPAIGN_COLUMNS,
  // DEFAULT_AUDIENCE_COLUMNS,
  // DEFAULT_CREATIVE_COLUMNS,
  // DEFAULT_SUBCHANNEL_COLUMNS,
  DEFAULT_ATTRIBUTION_WINDOWS,
  DEFAULT_COMPARISON_DATE_FILTER,
  UUID_V4_VALUES,
  INITIAL_VIEW_LAYOUT,
  DEFAULT_GRAPHBOXES_COLUMNS,
};
